import { render } from "./NurseRecruitmentPage.vue?vue&type=template&id=57b4ee24&scoped=true"
import script from "./NurseRecruitmentPage.vue?vue&type=script&lang=js"
export * from "./NurseRecruitmentPage.vue?vue&type=script&lang=js"

import "./NurseRecruitmentPage.vue?vue&type=style&index=0&id=57b4ee24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b4ee24"]])

export default __exports__